'use client';

import { memo, useCallback } from 'react';
import { ImageThumb, SquareButton } from '@/shared/ui';
import DeleteIcon from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_trash_fill.svg';
import styles from './styles.module.scss';

export interface ThumbnailProps {
  id: string;
  src?: string;
  state?: 'pending' | 'completed' | 'failed';
  order?: number;
  onDelete?: (id: string) => void;
}

export const Thumbnail = memo<ThumbnailProps>(
  ({ id, src, state = 'completed', order, onDelete }) => {
    const handleDelete = useCallback(() => {
      onDelete?.(id);
    }, [onDelete, id]);

    const style = {
      width: '102px',
      height: '102px',
      borderRadius: 'var(--radius-6)',
    };

    return (
      <ImageThumb
        thumbnailSize="small"
        src={src}
        isError={state === 'failed'}
        isLoading={state === 'pending'}
        alt={'thumbnail'}
        style={style}
        hoverContent={
          <div style={{ padding: '6px' }}>
            <SquareButton size="24" onClick={handleDelete}>
              <DeleteIcon />
            </SquareButton>
          </div>
        }
        badges={order && <div className={styles.orderBadge}>{order}</div>}
      />
    );
  },
);

Thumbnail.displayName = 'Thumbnail';
